import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderRateMiniEntity } from '../../domain/entities/OrderRateMiniEntity'

export class OrderRateMiniModel extends OrderRateMiniEntity {
  constructor(dataDto: OrderRateMiniEntity) {
    super()
    mapEntityProperties<OrderRateMiniModel>(this, dataDto)
  }
}
